module.exports = __webpack_public_path__ + "static/media/ac_square.35747b92.png";